if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.enableBackgroundClose();
      }

      enableBackgroundClose() {
        if (this._bgCloseReady) return;
        this._bgCloseReady = true;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        dialog.addEventListener('click', (e) => {
          if (e.target.closest('img, button, .slider-buttons, .image-magnify-full-size')) return;
          this.hide();
        });
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const slider = this.querySelector('slider-component');
        const slides = [...this.querySelectorAll('.product-media-modal__slide')];
        const targetSlide = slides.find(
          (slide) => slide.getAttribute('data-media-id') === mediaId
        );

        if (slider && targetSlide) {
          if (!slider.initialized) slider.initSlider();

          if (!slider._pointerGuard) {
            slider._pointerGuard = true;
            slider.addEventListener('pointerup', (event) => {
              event.stopPropagation();
            });
          }

          const track = slider.slider;
          track.style.scrollBehavior = 'auto';
          targetSlide.scrollIntoView({ inline: 'start', block: 'nearest' });
          track.style.scrollBehavior = '';
        }

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"] deferred-media`);
        if (activeMedia) {
          const template = activeMedia.querySelector('template');
          if (template && template.content.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
